<template>
  <section class="video">
    <div class="head">
      <span class="total">{{$t('global.共x个视频',{count:videoCount})}}</span>
      <div @click="showVideoSortList">
        <span>
          <img :src="sortVideoSelected.icon" />
          {{sortVideoSelected.title}}
        </span>
        <ul @click.stop="sortVideo" v-if="showVideoSort">
          <li v-for="item in sortList" :key="item.id" :data-sort="item._id">
            <img :src="item.icon" />
            {{item.title}}
          </li>
        </ul>
      </div>
    </div>
    <div class="video-list">
      <ul>
        <li v-for="item in videoList" :key="item.id">
          <VideoCard :item="item" :language="language" />
        </li>
      </ul>
      <Loading v-if="loading" />
      <Reload v-if="loadError" @callback="loadMore" />
      <no-more v-if="!hasNextPage && videoList.length" />
    </div>
  </section>
</template>

<script>
import VideoCard from "@/components/v2/match/videoCard";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  components: {
    VideoCard: VideoCard,
    Reload,
    NoMore,
    Loading
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  data() {
    return {
      showVideoSort: false,
      loading: false,
      hasMore: true,
      loadError: false,
      hasNextPage: true,
      videoList: [],
      videoCount: 0,
      pageIndex: 1,
      pageSize: 18,
      sortVideoSelected: {
        id: "0",
        _id: 0,
        icon: "/static/v2/match/sort_default.png",
        title: this.$t("global.默认排序")
      },
      sortList: [
        {
          id: "0",
          _id: 0,
          icon: "/static/v2/match/sort_default.png",
          title: this.$t("global.默认排序")
        },
        {
          id: "1",
          _id: 1,
          icon: "/static/v2/match/sort_latest.png",
          title: this.$t("global.最新排序")
        },
        {
          id: "5",
          _id: 2,
          icon: "/static/v2/match/sort_hot.png",
          title: this.$t("global.热门排序")
        }
      ]
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    init() {
      this.topicId = this.$route.params.id;
      this.getVideoList();
    },
    showVideoSortList() {
      this.showVideoSort = true;
    },
    sortVideo() {
      this.sortVideoSelected = this.sortList[
        event.target.getAttribute("data-sort")
      ];
      this.showVideoSort = false;
      this.pageIndex = 1;
      this.getVideoList();
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 20) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getVideoList();
        }
      }
    },
    getVideoList() {
      this.loading = true;
      const url = "/api/topic/videoList";
      const params = {
        topicId: this.topicId,
        status: 2,
        orderByType: this.sortVideoSelected.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          if (this.pageIndex === 1) {
            this.videoList = [];
          }
          this.loadError = false;
          this.videoList = [...this.videoList, ...res.data.list];
          this.videoCount = res.data.totalRecord;
          this.hasNextPage = res.data.hasNextPage;
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
          this.loadError = true;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.video {
  .head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .total {
      color: #999999;
      font-size: 15px;
      font-weight: 500;
      padding: 30px 0;
    }

    div {
      line-height: 33px;
      text-align: center;
      position: relative;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      span {
        cursor: pointer;
        display: inline-block;
        color: #0A0A0A;
        font-size: 12px;
        cursor: pointer;
        line-height: 16px;
        margin-top: 5px;

        img {
          width: 18px;
          height: 18px;
          vertical-align: sub;
          margin-top: 4px;
        }
      }

      ul {
        width: 125px;
        box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
        border: 1px solid rgba(235, 235, 235, 1);
        position: absolute;
        top: 33px;
        left: -26px;
        z-index: 1;
        background: #fff;
        padding: 10px 0;

        li {
          line-height: 34px;
          cursor: pointer;

          &:hover {
            background: #F5F5F5;
          }

          img {
            width: 18px;
            height: 18px;
            vertical-align: sub;
          }
        }
      }
    }
  }

  .video-list {
    padding-bottom: 40px;

    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        width: 350px;
        margin: 0 30px 30px 0;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/channel/Video.vue